export default {
  LIST_FETCHED: 'USER_SHOPPING_CART_FETCHED',
  LIST_LOAD: 'USER_SHOPPING_CART_LOAD',
  ITEM_DETAIL: 'USER_SHOPPING_CART_DETAIL',
  BUTTON_LOAD: 'USER_SHOPPING_CART_BUTTON_LOAD',
  COUPON_APPLY_REQUEST: 'USER_SHOPPING_CART_COUPON_APPLY_REQUEST',
  COUPON_APPLY_SUCCESS: 'USER_SHOPPING_CART_COUPON_APPLY_SUCCESS',
  COUPON_APPLY_FAILURE: 'USER_SHOPPING_CART_COUPON_APPLY_FAILURE',
  COUPON_CLEAR: 'USER_SHOPPING_CART_COUPON_CLEAR',
};
